import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { initBrowserSentry } from '@common/configs/sentry.browser.config';
import { EEnvTypes } from '@common/enums/env-types.enum';

import { AppModule } from './app/app.module';

import { environment } from './environments/environment';

initBrowserSentry({
    dsn: 'https://94c7f843bbd0f83905e376fc44727133@sentry.sendpulse.com/21',
    environment: environment.type,
    project: 'websites',
});

if (environment.production) {
    enableProdMode();
}

async function devAuth(): Promise<void> {
    if (environment.type !== EEnvTypes.DEV) return;
    try {
        const res = await fetch('assets/dev-auth.json');
        if (!res.ok) return;
        const { access_token } = (await res.json()) as { access_token?: string };
        if (access_token) {
            document.cookie = `oauth_access_token=${access_token}; path=/`;
        }
    } catch {
        // No dev auth token available — skip silently
    }
}

devAuth().then(() => {
    platformBrowserDynamic()
        .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()] })
        .catch((err) => console.error(err));
});
